let API;

const g = window || global;

if (g.cloudpivotDomainAPI) {
  API = g.cloudpivotDomainAPI;
} else {
  if (process.env.NODE_ENV === 'production') {
    require('./lib/style');
    API = require('./lib');
  } else {
    API = require('./src');
  }
  g.cloudpivotDomainAPI = API;
}

module.exports = API;
